import { render, staticRenderFns } from "./GoogleIntegrationButton.vue?vue&type=template&id=b5a32f22"
import script from "./GoogleIntegrationButton.vue?vue&type=script&lang=js"
export * from "./GoogleIntegrationButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports